// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"Feedback_feedbackContainer__4o2kE"};